import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/RhytNotation/editor/rhytnotationeditor.tsx",
    () => import("./rhytnotationeditor"),
);
